module.exports = __webpack_public_path__ + "img/banner_082402.bcf4377b.png";